<div class="flex h-screen flex-col">
  <div class="relative flex h-24 shrink-0 items-center justify-center px-6 pt-4 mb-4">
    <div class="absolute left-2 top-2 p-4 lg:hidden">
      <p-button
        [rounded]="true"
        (click)="closeCallback.emit()"
        severity="secondary"
      >
        <span class="material-icons"> close </span>
      </p-button>
    </div>
    <div class="absolute right-0 top-2 hidden p-4 lg:-right-9 lg:block">
      <p-button
        [rounded]="true"
        (click)="closeCallback.emit()"
        severity="secondary"
        ><span class="material-icons">chevron_left</span></p-button
      >
    </div>
    <bk-logo class="h-full w-72 px-8"></bk-logo>
  </div>
  <div class="overflow-y-auto">
    <bk-sidebar-menu
      [navItems]="navItems()"
      (closeMenu)="navCallback.emit()"
      title="Application"
    ></bk-sidebar-menu>
    <bk-sidebar-menu
      [navItems]="settings()"
      (closeMenu)="navCallback.emit()"
      title="Settings"
    ></bk-sidebar-menu>
  </div>
  <div class="mt-auto pb-2">
    <hr class="mx-4 mb-2 border-0 border-t border-surface" />
    <bk-user-card class="mb-4"></bk-user-card>
  </div>
</div>
